import { NS as MAP_NS } from '../constants';

const NS = 'trafficOverlays';

export const SET_DATA = `${MAP_NS}/${NS}/SET_DATA`;
export const SET_TYPE = `${MAP_NS}/${NS}/SET_TYPE`;
export const SET_IS_ACTIVE = `${MAP_NS}/${NS}/SET_IS_ACTIVE`;
